import NutritionSettingsWrapper from './NutritionSettingsWrapper';

export default NutritionSettingsWrapper;
